<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-11 22:33:54
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        size="small"
        label-width="120px"
        disabled
      >
      <el-descriptions
        class="margin-top"
        title="人员信息"
        :column="2"
        border
      >
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            用户姓名
          </template>
          {{ form.userName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            用户电话
          </template>
          {{ form.phone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            用户地址
          </template>
          {{ form.wlUserAddress + form.wlUserAddressDetail }}
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        class="margin-top"
        title="订单信息"
        :column="3"
        border
      >
        <el-descriptions-item>
          <template slot="label">
            订单号
          </template>
          {{ form.orderNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            订单创建时间
          </template>
          {{ form.orderTime }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            订单预约时间
          </template>
          {{ form.appointmentTime }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            订单状态
          </template>
          {{ stateCode[form.state] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            订单总价
          </template>
          {{ form.totalPrice }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            支付时间
          </template>
          {{ form.payTime }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            支付方式
          </template>
          {{ payTypeCode[form.payType] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            实付款
          </template>
          {{ form.epgPaymentAmount + form.otherPaymentAmount }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            环保金支付金额
          </template>
          {{ form.epgPaymentAmount }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            其他支付金额
          </template>
          {{ form.otherPaymentAmount }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            应付款
          </template>
          {{ form.payPrice }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            大件规格
          </template>
          {{ form.hapName }}
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            下单人电话
          </template>
          {{ form.phone }}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">
            备注
          </template>
          {{ form.userRemark }}
        </el-descriptions-item>
      </el-descriptions>

      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import { listMixin } from "@/mixins/listMixin";

export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      defaultProps_menu: {
        children: "childers",
        label: "name",
      },
      menuTreeData: [],
      disableMixinCreated: true,
      options: [
        { label: "普通用户", value: 0 },
        { label: "管理员", value: 1 },
      ],
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: {},
      stateCode: {
        1: "待接单",
        2: "进行中",
        3: "已完成",
        4: "已取消",
      },
      payTypeCode: {
        1: "环保金支付",
        2: "微信支付",
        3: "组合支付",
      },
      expressStateCode: {
        1: "待发货",
        2: "已发货",
        3: "运输中",
        4: "已签收",
        5: "已拒收",
      },
      url: {
        // add: 'role/addRole',
        queryOrderInfo: "/wlBulkyOrder/detail",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    // add() {
    //   this.edit({});
    // },
    async edit(record) {
      console.log(record);
      this.visible = true;
      let res = await httpAction(
        this.url.queryOrderInfo + "?id=" + record.id,
        {},
        "get"
      );
      if (res.code == 200) {
        this.form = { ...res.data };
      } else {
        this.$message.warning(res.msg);
      }
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit("close");
      this.visible = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
  .detail_personInfo {
    background: #f5f2f2;

    .detail_personInfo_title {
      height: 30px;
      text-align: center;
      line-height: 30px;
    }
    .detail_personInfo_main {
      // background: red;
      .detail_personInfo_main_item {
        height: 30px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-top: 1px solid #e3e2e2;
      }
    }
  }
}
</style>
